import { useEffect, useState } from "react";
import { billsApi } from "@/lib/billsNative";

// READ-ONLY authority lookup. null = feature OFF / unavailable → legacy UX unchanged. Never claims.
export function useBillsAuthority(candidateId) {
  const [authority, setAuthority] = useState(null);
  useEffect(() => {
    let live = true;
    billsApi.authority(candidateId).then((r) => live && setAuthority(r.ok ? r.data.authority : null));
    return () => { live = false; };
  }, [candidateId]);
  return authority;
}
